// extracted by mini-css-extract-plugin
export default {"container":"Jdv-g9vMjZ","uplink":"XD0Yrnx7kr","downlink":"No+akgEKgS","policy":"hMAe8wicuN","icon":"Mw32CcVr7K"};